import React from "react";
import { Box, useTheme } from "@mui/material";

export interface IDotLegalTabPanel {
    children?: React.ReactNode;
    index: any;
    value: any;
    noPadding?: boolean;
    border?: boolean;
    fillColumn?: boolean;
    tabsFullWidth?: boolean;
}

export const dotLegalTabPanelNoPadding = 0.5;
function DotLegalTabPanel(props: IDotLegalTabPanel) {
    let theme = useTheme();
    const { children, value, index, noPadding } = props;
    const padding = noPadding ? 0 : 3;
    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            sx={{
                ...(props.border && {
                    borderLeft: `1px solid ${theme.palette.primary.light}`,
                    borderRight: `1px solid ${theme.palette.primary.light}`,
                    borderBottom: `1px solid ${theme.palette.primary.light}`,
                    borderBottomLeftRadius: "10px",
                    borderBottomRightRadius: "10px",
                }),
                ...(props.fillColumn && value === index && { flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }),
            }}
        >
            {value === index && (
                <Box
                    sx={{
                        paddingTop: noPadding ? dotLegalTabPanelNoPadding : 3,
                        paddingLeft: padding,
                        paddingRight: padding,
                        paddingBottom: padding,
                        ...(props.fillColumn && { flex: 1, display: "flex", flexDirection: "column" }),
                        ...(props.tabsFullWidth && { "& .MuiPaper-root": { borderTopRightRadius: 0 } }),
                    }}
                >
                    {children}
                </Box>
            )}
        </Box>
    );
}

export default DotLegalTabPanel;
